// @flow
import React from "react";
import Narrow from "../../../svg/facilities/is_narrow.svg";
import "./narrowIcon.scss";

const NarrowIcon = () => <Narrow className="c-narrow-icon" />;

export default NarrowIcon;
